export enum modalType {
    RE_TRY_WARNING = 'reTryWarning',
    ALERT = 'alert',
    MAX_TRY = 'maxTry',
    NOT_CAMERA_SUPPORTED = 'notCameraSupport',
    NOT_FACE_DETECTED = 'noFaceDetected',
    SEVERAL_FACE = 'severalFaces',
    FARE_FACE = 'farFace',
    COMPLETE = 'complete',
    MISMATCH = 'mismatch',
    EDIT_PERSONAL_INFO = 'editPersonalInfo',
}
